import { motion } from "framer-motion";
import { BadgeEuro, CalendarClock, PackageCheck, ArrowUpRight } from "lucide-react";
import { scrollToId } from "@/components/Nav";

const items = [
  {
    icon: BadgeEuro,
    title: "Zero intermediazione",
    desc: "Nessuna provvigione alle agenzie immobiliari: promozione, selezione dell'inquilino e messa a reddito della tua casa non ti costano nulla.",
  },
  {
    icon: CalendarClock,
    title: "Solo a contratto attivo",
    desc: "Una quota fissa del 9% sul canone mensile, uguale per proprietario e inquilino: dovuta esclusivamente finché la locazione è attiva. Casa sfitta? Non paghi nulla.",
  },
  {
    icon: PackageCheck,
    title: "Tutto incluso",
    desc: "Nella quota sono compresi gestione dell'incasso, indennizzo del 100% del canone fino a 3 mensilità, tutela legale, servizio ticket SOS e area riservata Semplificapp.",
  },
];

export default function Costs() {
  return (
    <section id="costi" data-testid="costs-section" className="bg-white border-y border-ink/10 py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6 }}
          className="eyebrow text-brandblue mb-6"
        >
          Quanto costa
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7 }}
          className="font-serif font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight max-w-3xl leading-[1.12] mb-6"
        >
          Una quota. <span className="italic text-brandblue">Solo quando guadagni.</span>
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7, delay: 0.08 }}
          className="text-base lg:text-lg text-ink/60 leading-relaxed max-w-2xl mb-14"
        >
          Niente costi nascosti e niente sorprese: il modello di
          Semplificaffitto.it è a consumo e si ripaga da solo.
        </motion.p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {items.map((it, i) => (
            <motion.div
              key={it.title}
              initial={{ opacity: 0, y: 26 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              data-testid={`cost-card-${i + 1}`}
              className="rounded-2xl bg-paper border border-ink/10 p-8 hover:border-azure/40 hover:shadow-[0_14px_36px_rgba(0,157,223,0.12)] transition-[box-shadow,border-color] duration-300"
            >
              <span className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-azure/10 text-brandblue mb-5">
                <it.icon size={22} />
              </span>
              <h3 className="font-serif font-semibold text-xl">{it.title}</h3>
              <p className="mt-3 text-sm text-ink/60 leading-relaxed">{it.desc}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ duration: 0.7, delay: 0.15 }}
          className="mt-12 flex flex-col sm:flex-row items-start sm:items-center gap-6"
        >
          <p className="text-sm text-ink/55 leading-relaxed max-w-xl">
            Quota trasparente e fissa: 9% del canone, uguale per proprietario e inquilino, solo a
            contratto attivo. Richiedi un preventivo gratuito: saprai esattamente quanto guadagni e quanto spendi, prima di firmare qualsiasi cosa.
          </p>
          <a
            href="#contatti"
            data-testid="costs-cta-btn"
            onClick={(e) => {
              e.preventDefault();
              scrollToId("#contatti");
            }}
            className="group shrink-0 inline-flex items-center gap-2 bg-ink text-white font-semibold rounded-full px-7 py-4 text-sm hover:bg-brandblue transition-colors duration-300"
          >
            Richiedi il preventivo gratuito
            <ArrowUpRight size={18} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
        </motion.div>
      </div>
    </section>
  );
}
